import he from '../i18n/he';
import { messageForError } from '../i18n/errors';

export const Loader = () => <div className="loader">{he.common.loading}</div>;

export const ErrorText = ({ error }) => (
  <div className="error-text">{messageForError(error)}</div>
);

// Renders loader/error/empty around a successful child, so views stay clean.
export default function AsyncBoundary({ loading, error, children }) {
  if (loading) return <Loader />;
  if (error) return <ErrorText error={error} />;
  return children;
}
